export default __webpack_public_path__ + "static/media/rawbaracuda.8473a48a.PNG";